// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-row {
  background: white;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  margin-bottom: 8px;
  padding: 5px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  height: 100%;
  display: block;
}
.item-row .not-order-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-row .not-order-item .text-not-visible {
  opacity: 1;
  background: rgb(169, 169, 169);
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  color: white;
  padding: 3px 5px;
  border-radius: 2px;
  font-size: 14px;
}
.item-row .img-block {
  position: relative;
}
.item-row .img-block .amount-in-basket {
  position: absolute;
  display: flex;
  align-items: center;
  background: var(--ion-color-secondary);
  border-radius: 20px;
  top: 5px;
  left: 5px;
  height: 20px;
}
.item-row .img-block .amount-in-basket ion-icon {
  width: 20px;
  height: 20px;
}
.item-row .img-block .amount-in-basket p {
  padding: 0px 10px 0px 5px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
.item-row .img-block .section_favourite {
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: var(--ion-color-primary);
  border-top-right-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
}
.item-row .img-block .section_favourite ion-icon {
  zoom: 1.3;
}
.item-row .img-block .tags_article {
  position: absolute;
  z-index: 99;
  zoom: 3;
  right: 5%;
  top: 5%;
}
.item-row .item-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  overflow: hidden;
  margin: 0px !important;
  min-height: 130px;
}
.item-row .item-image.default-image {
  padding: 20px;
  object-fit: contain;
}
@media (max-width: 992px) {
  .item-row .item-image {
    min-height: 110px;
  }
}
.item-row .item-text {
  padding: 20px 10px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.item-row .item-text .block_type {
  position: absolute;
  top: 10px;
  right: 0px;
  padding: 5px;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  z-index: 99;
}
.item-row .item-text .block_type ion-icon {
  zoom: 1.2;
  margin-right: 5px;
}

.item-name {
  font-size: 16px;
  line-height: var(--item-view-title-line-height);
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  margin-right: 65px;
  text-transform: capitalize;
}
.item-name ion-icon {
  width: 20px;
  height: 17px;
}

.item-info {
  padding-top: 10px;
  font-size: var(--item-view-info-font-size);
  line-height: var(--item-view-info-line-height);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #899589;
}

.price-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 10px 5px 0px;
  justify-content: flex-start;
}
.price-col .action-icon {
  width: 22px;
  height: 22px;
}
@media (min-width: 991px) {
  .price-col .action-icon {
    display: none;
  }
}

.price {
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
}
@media (min-width: 991px) {
  .price {
    margin-bottom: 2px;
  }
}
@media (max-width: 992px) {
  .price {
    text-align: right;
  }
}

.small-screen {
  display: flex;
  padding: 0px;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  margin-top: 7px;
}
@media (max-width: 992px) {
  .measurment_text {
    text-align: left;
  }
}

.vat {
  color: black;
  font-size: 10px;
}

.vegan-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  font-size: 8px;
  color: #7EA769;
}

.add-opacity {
  opacity: 0.6;
}

.price-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  align-items: center;
}

.name-section {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EAEA,2DAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EA0GE,eAAA;EACA,YAAA;EACA,cAAA;AA3GJ;AAAE;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACE,UAAA;EAEA,8BAAA;EACA,2DAAA;EAEA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AADN;AAOE;EACE,kBAAA;AALJ;AAMI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAJN;AAKM;EACE,WAAA;EACA,YAAA;AAHR;AAKM;EACE,yBAAA;EACA,YAAA;EACA,oCAAA;AAHR;AAMI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oCAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAJN;AAKM;EACE,SAAA;AAHR;AAMI;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,OAAA;AAJN;AAOE;EAEE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AANJ;AAOI;EACE,aAAA;EACA,mBAAA;AALN;AC1EE;EDoEA;IAcI,iBAAA;EAJJ;AACF;AAOE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AALJ;AAMI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,2DAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAJN;AAKM;EACE,SAAA;EACA,iBAAA;AAHR;;AAWA;EACE,eAAA;EACA,+CAAA;EAEA,iCAAA;EACA,oCAAA;EACA,kBAAA;EACA,0BAAA;AATF;AAWE;EACE,WAAA;EACA,YAAA;AATJ;;AAaA;EACE,iBAAA;EACA,0CAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAVF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;AAXF;AAeE;EACE,WAAA;EACA,YAAA;AAbJ;AClJE;ED6JA;IAII,aAAA;EAXJ;AACF;;AAcA;EAEE,iCAAA;EACA,oCAAA;EACA,eAAA;AAZF;AC7JE;EDqKF;IAOK,kBAAA;EAXH;AACF;AC5JE;ED+JF;IAWI,iBAAA;EAVF;AACF;;AAiBA;EACE,aAAA;EACA,YAAA;AAdF;;AAkBA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAfD;AC9KE;EDwLF;IAOE,gBAAA;EAbA;AACF;;AAeA;EACE,YAAA;EACA,eAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAZF;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;AAaE;EACE,cAAA;EACA,cAAA;AAXJ;;AAcA;EACE,YAAA;AAXF;;AAaA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAYA;EACE,aAAA;EACA,sBAAA;AATF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.item-row {\n  background: white;\n  // border: var(--item-view-border);\n  box-shadow: 0px 0px 20px 0px #4F614F26;\n  margin-bottom: 8px;\n  padding: 5px;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n  .not-order-item {\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .text-not-visible {\n      opacity: 1;\n\n      background: rgb(169, 169, 169);\n      box-shadow: 0px 0px 20px 0px #4F614F26;\n\n      color: white;\n      padding: 3px 5px;\n      border-radius: 2px;\n      font-size: 14px;\n    \n\n    }\n    \n  }\n  .img-block {\n    position: relative;\n    .amount-in-basket {\n      position: absolute;\n      display: flex;\n      align-items: center;\n      background: var(--ion-color-secondary);\n      border-radius: 20px;\n      top: 5px;\n      left: 5px;\n      height: 20px;\n      ion-icon {\n        width: 20px;\n        height: 20px;\n      }\n      p {\n        padding: 0px 10px 0px 5px;\n        color: white;\n        font-family: AppFontBold, sans-serif;\n      }\n    }\n    .section_favourite {\n      position: absolute;\n      bottom: 0px;\n      left: 0px;\n      background: var(--ion-color-primary);\n      border-top-right-radius: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 3px;\n      ion-icon {\n        zoom: 1.3;\n      }\n    }\n    .tags_article {\n      position: absolute;\n      z-index: 99;\n      zoom: 3;\n      right: 5%;\n      top: 5%;\n    }\n  }\n  .item-image {\n\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    border-radius: 10px;\n    overflow: hidden;\n    margin: 0px !important;\n    min-height: 130px;\n    &.default-image {\n      padding: 20px;\n      object-fit: contain;\n    }\n    @include mobile {\n      min-height: 110px;\n    }\n  }\n  \n  .item-text {\n    padding: 20px 10px 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: relative;\n    .block_type {\n      position: absolute;\n      top: 10px;\n      right: 0px;\n      padding: 5px;\n      box-shadow: 0px 0px 20px 0px #4F614F26;\n      border-top-left-radius: 10px;\n      border-bottom-left-radius: 10px;\n      display: flex;\n      align-items: center;\n      z-index: 99;\n      ion-icon {\n        zoom: 1.2;\n        margin-right: 5px;\n      }\n    }\n  }\n    cursor: pointer;\n    height: 100%;\n    display: block;\n}\n.item-name {\n  font-size:16px;\n  line-height: var(--item-view-title-line-height);\n\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold, sans-serif;\n  margin-right: 65px;\n  text-transform: capitalize;\n\n  ion-icon {\n    width: 20px;\n    height: 17px;\n  }\n}\n\n.item-info {\n  padding-top: 10px;\n  font-size: var(--item-view-info-font-size);\n  line-height: var(--item-view-info-line-height);\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical ;\n  overflow: hidden ;\n  text-overflow: ellipsis;\n  color: #899589;\n\n}\n\n.price-col {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 10px 10px 5px 0px;\n  justify-content: flex-start;\n\n\n\n  .action-icon {\n    width: 22px;\n    height: 22px;\n    @include desktop {\n      display: none;\n    }\n  }\n}\n.price {    \n  // margin-bottom: 12px;\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold ,sans-serif;\n  font-size: 16px;\n\n   @include desktop {\n     margin-bottom: 2px;\n\n  }\n  @include mobile {\n    text-align: right;\n  }\n}\n\n\n\n\n\n.small-screen {\n  display: flex;\n  padding: 0px\n}\n\n\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: right;\n\tmargin-top: 7px;\n\t@include mobile {\n\t\ttext-align: left;\n\t}\n}\n.vat {\n  color: black;\n  font-size: 10px;\n  \n}\n.vegan-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; \n  align-items: center;\n  padding-right: 5px;\n  ion-img {\n    width: 35px;\n    height: 24px;\n  }\n  p {\n    font-size: 8px;\n    color: #7EA769;\n  }\n}\n.add-opacity {\n  opacity: 0.6;\n}\n.price-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 5px;\n  align-items: center;\n}\n.name-section {\n  display: flex;\n  flex-direction: column;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
